import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { APP_ROUTES } from '../../app.routes';

@Injectable({
  providedIn: 'root',
})
export class DevelopmentGuard implements CanActivate {
  constructor(private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._getEnvironmentConfig();
  }

  private _getEnvironmentConfig(): boolean | UrlTree {
    const { isTestServer, production } = environment;
    return isTestServer && !production ? true : this._router.createUrlTree([APP_ROUTES.AUTH]);
  }
}
